import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const NewMexico = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>New Mexico Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Standard disclosure of known defects required; no specific form
          mandated.
        </Text>
      </View>
    </View>
  );
};

export default NewMexico;
